import React, {Component} from 'react';
import moment from 'moment';
import {DATE_FORMAT, DATE_TIME_FORMAT, DATE_YEAR_FORMAT, stringIsEmpty} from './StringTools';
import TableOptions from './TableOptions';
import PropTypes from 'prop-types';
import {Col, Row} from 'reactstrap';
import {MOBILE_SCREEN_WIDTH} from './MobileUtils';
import {getBaseApiUrl} from './AppContextTools';
import _ from 'lodash';

export default class ResourceComponent extends Component {
    defaultMapCenter = {lat: 39, long: -96};

    responsiveColumns = (columns, label) => {
        if (window.innerWidth > MOBILE_SCREEN_WIDTH) {
            return columns;
        }
        return [{
            dataField: 'id',
            text: label,
            formatter: (cell, row) => (
                <div>
                    {columns.map(
                        (col, i) =>
                            <Row key={i}>
                                <Col xs={5} className='text-right'>
                                    {col.text}:
                                </Col>
                                <Col xs={7}>
                                    <b>{col.formatter ? col.formatter(row[col.dataField], row) : row[col.dataField]}</b>
                                </Col>
                            </Row>,
                    )}
                </div>
            ),
        }];

    };

    kmToMiles = (km) => parseFloat(km) * 0.621371192;
    milesToKm = (ml) => parseFloat(ml) * 1.609344;

    getBounds = (points) => {
        let result;
        if (points && points.length > 0) {
            let allLongitudes = [];
            let allLatitudes = [];
            points.forEach(point => {
                allLongitudes.push(point.long);
                allLatitudes.push(point.lat);
            });
            allLongitudes.sort((a, b) => a - b);
            allLatitudes.sort((a, b) => a - b);
            result = [
                [allLongitudes[0] - 1, allLatitudes[0] - 1],
                [allLongitudes[allLongitudes.length - 1] + 1.0, allLatitudes[allLatitudes.length - 1] + 1.0],
            ];
        }
        return result;
    };

    formatDateTime = (valueToFormat) => {
        return valueToFormat ? moment(valueToFormat).format(DATE_TIME_FORMAT) : null;
    };

    formatDate = (valueToFormat) => {
        return valueToFormat ? moment(valueToFormat).format(DATE_FORMAT) : null;
    };

    onTextChange = (name, callback) => e => {
        const {resource} = this.state;
        let newResource = {...resource};
        newResource[name] = e.target.value;
        this.setState({resource: newResource}, callback);
    };

    onColorChange = (name, callback) => color => {
        const {resource} = this.state;
        let newResource = {...resource};
        newResource[name] = color.hex;
        this.setState({resource: newResource}, callback);
    };

    onDateTimeChange = (name, callback) => e => {
        this.onDatepickerChange(name, callback)(e);
    };

    onDateChange = (name, callback) => e => {
        this.onDatepickerChange(name, callback)(e);
    };

    onYearChange = (name, callback) => e => {
        this.onDatepickerChange(name, callback, DATE_YEAR_FORMAT)(e);
    };

    onDatepickerChange = (name, callback, format) => e => {
        const {resource} = this.state;
        let newResource = {...resource};
        let newValue = e ? (e instanceof moment ? e : moment(e)) : null;
        if (format && newValue) {
            newValue = e.format(format);
        }
        if (newValue !== 'Invalid date') {
            newResource[name] = newValue;
            this.setState({resource: newResource}, callback);
        }
        //    TODO: it's hard to enter the date from keyboard
    };

    onPasswordPick = () => {
        const {resource} = this.state;
        if (this.state.passwordChange === false) {
            this.setState({
                resource: {
                    ...resource,
                    password: '',
                    repeatedPassword: '',
                },
            });
            this.setState({passwordChange: true});
        }
        if (this.state.passwordChange === true) {
            this.setState({
                resource: {
                    ...resource,
                    password: null,
                    repeatedPassword: null,
                    validationErrors: null,
                },
            });
            this.setState({passwordChange: false});
        }
    };

    onCheck = (name, callback) => (e) => {
        const {resource} = this.state;
        resource[name] = e.target.checked;
        this.setState({resource}, callback);
    };

    threeValueCheck = (name, callback) => () => {
        const {resource} = this.state;
        const checked = resource[name];

        if (checked === undefined) {
            resource[name] = true;
        } else if (checked === true) {
            resource[name] = false;
        } else if (checked === false) {
            resource[name] = undefined;
        }
        this.setState({resource}, callback);
    };

    onSubmit = (e, callback) => {
        e.preventDefault();
        const {resource} = this.state;
        this.setState({submitted: true});
        if (Object.keys(resource.validationErrors).length === 0) {
            delete resource.validationErrors;
            callback(resource);
        }
    };

    sameValueValidator = (fieldToCompare) => {
        this.validator(fieldToCompare, value => {
            let pass = this.state.resource.password;
            return {
                valid: pass === value,
                message: 'must be same.',
            };
        });
    };

    requiredValidator = (fieldName) => {
        this.validator(fieldName, value => {
            return {
                valid: !stringIsEmpty(value),
                message: 'is required',
            };
        });
    };

    numberValidator = (fieldName) => {
        this.validator(fieldName, v => {
            return {
                valid: !stringIsEmpty(v) && Number(v) > 0,
                message: 'is required and must be greater than 0',
            };
        });
    };

    objectValidator = (fieldName) => {
        this.validator(fieldName, value => {
            return {
                valid: (value !== null),
                message: 'is required',
            };
        });
    };

    lengthValidator = (min = 0, max = 255) => (fieldName) => {
        this.validator(fieldName, value => {
            const length = value.length;
            return {
                valid: length >= min && length <= max,
                message: 'invalid length',
            };
        });
    };
    validator = (fieldName, isValid) => {
        const {resource} = this.state;
        const validationResult = isValid(resource[fieldName]);
        if (!resource.validationErrors) {
            resource.validationErrors = {};
        }
        const validationErrors = resource.validationErrors;
        if (!validationResult.valid) {
            validationErrors[fieldName] = (validationResult.message);
        } else {
            delete validationErrors[fieldName];
        }
        if ((validationErrors[fieldName] && validationResult.valid)
            || (!validationErrors[fieldName] && !validationResult.valid)) {
            this.setState({resource});
        }
    };

    buildEnumSearchComponent = (field, values) => {
        return this.buildSearchComponent(field,
            (e, callback) => callback(values),
            '',
            (candidate, selected) => candidate.value === selected,
            (x) => x.value,
            (x) => ({value: x, label: x}),
            (a1, a2) => [...new Set([...a1, ...a2])]);
    };

    buildSearchComponent = (
        field,
        searchFn,
        initialValue = '',
        eqFn = (candidate, selected) => candidate.value == selected.id, // don't remove: works for both string keys and numbers
        toValue = (x) => ({id: x.value, name: x.label}),
        toOption = (s) => ({value: s.id, label: s.name}),
        concat = (array1, array2) => {
            const map = {};
            array1.forEach(x => map[x.id] = x.name);
            array2.forEach(x => map[x.id] = x.name);
            return Object.keys(map).map(x => ({id: x, name: map[x]}));
        }) => {
        const fieldOptions = `${field}Options`;

        const searchOptions = () => {
            let selectedOptions = this.state.resource[field] || [];
            if (selectedOptions && selectedOptions.constructor.name !== 'Array') {
                selectedOptions = [selectedOptions];
            }
            let currentSearch = this.state[fieldOptions] || [];
            currentSearch = concat(currentSearch, selectedOptions);
            return currentSearch.map(toOption).sort((a, b) => a.label && b.label && a.label.localeCompare(b.label));
        };

        const debouncedSearchFn = _.debounce(searchFn, 300);

        const search = (e, setValues = false) => {
            debouncedSearchFn(e, result => {
                const {resource} = this.state;
                const newState = {};
                newState[fieldOptions] = result;
                if (setValues === true) {
                    resource[field] = result;
                    newState.resource = resource;
                }
                this.setState(newState);
            });
        };

        const value = () => {
            const all = searchOptions();
            const e = this.state.resource[field];
            if (e && e.constructor.name === 'Array') {
                return e.map(selected => {
                    return all.find(a => eqFn(a, selected));
                });
            } else {
                return e ? all.find(a => eqFn(a, e)) : e;
            }
        };

        const setSearchOptions = () => {
            const newState = {};
            newState[fieldOptions] = [];
            this.setState(newState);
        };

        const onSelect = (callback = () => {
        }) => e => {
            const {resource} = this.state;
            let newResource = {...resource};
            if (e && e.constructor.name === 'Array') {
                newResource[field] = e.map(x => toValue(x));
            } else {
                newResource[field] = e ? toValue(e) : null;
            }
            this.setState({resource: newResource}, callback);
        };

        setSearchOptions();
        search(initialValue, initialValue !== '' && initialValue != null);
        return {search, searchOptions, value, onSelect};
    };

    delete = (fieldName, row) => {
        const {resource} = this.state;
        const newResource = {
            ...resource,
        };
        newResource[fieldName] = resource[fieldName].filter(s => s !== row);
        this.setState({resource: newResource});
    };

    validationState(fieldName, validator) {
        const {resource, submitted} = this.state;
        validator(fieldName);
        return submitted ? (resource.validationErrors[fieldName]) : false;
    }

    getUrl = (id, qrFor) => {
        const domain = getBaseApiUrl();
        return `${domain}/qr/image?id=${id}&${qrFor}`;
    };

    // Reset filters
    resetFilters = () => {
        let {resource, filters} = this.state;
        resource = {...resource, ...filters};
        this.setState({resource, resetSliderTime: moment()}, () => {
            this.reloadFilters();
            this.delayedSearch();
        });
    };

    //Pictures functions
    openGallery = (picId) => {
        const pictureIndex = this.state.resource.pictures.findIndex(p => p.id === picId);
        this.setState({pictureIndex: pictureIndex, lightbox: true});
    };

    incrementIndex = () => {
        const current = this.state.pictureIndex;
        const last = this.state.resource.pictures.length - 1;
        if (current !== last) {
            this.setState({pictureIndex: current + 1});
        }
    };

    decrementIndex = () => {
        const current = this.state.pictureIndex;
        if (current !== 0) {
            this.setState({pictureIndex: current - 1});
        }
    };

    handleMoveSlide = (direction, current, pictures) => {
        const last = pictures.length - 1;

        direction === 'next' ? current += 1
            : current -= 1;

        if (current > last) {
            current = 0;
        } else if (current < 0) {
            current = last;
        }
        this.setState({lightboxPicture: {...pictures[current], pictures}, shouldUpdate: !this.state.shouldUpdate});
    };

    deletePic = (id) => {
        let {resource} = this.state;
        if (resource.picture_id === id) {
            resource.picture_id = null;
            resource.picture_url = null;
        }
        resource.pictures = resource.pictures.filter(p => p.id !== id);
        this.setState({resource: resource});
    };

    updatePicCaption = (pic_id, fn) => {
        const picture = this.state.resource.pictures.find(x => x.id === pic_id);
        fn(pic_id, picture, 'Image caption updated!');
    };

    setAsMainPic = (id) => {
        const pic = this.state.resource.pictures.find(p => p.id === id);
        const {resource} = this.state;
        resource.picture_id = pic.id;
        resource.picture_url = pic.url;
        this.setState({resource});
    };


    // Tab toggler
    toggleTab = (tabNm) => {
        if (this.state.activeTab !== tabNm) {
            this.setState({
                activeTab: tabNm,
            });
        }
    };

    // Filter setter
    loadFilters = (filters, thickSearchFn) => {
        this.setState(state => {
            state.filters = {...state.filters, ...filters};
            state.resource = {...state.resource, ...state.filters, ...filters};
            return state;
        }, () => {
            this.search();
            thickSearchFn({page: 1, per_page: 999}, thicks => {
                if (thicks && thicks.length > 0) {
                    const {resource, filters} = this.state;
                    thicks.forEach(t => t.thickness = parseFloat(t.thickness));
                    thicks.sort((a, b) => a.thickness - b.thickness);
                    resource.thicks = thicks;
                    filters.thickness.min = thicks[0].thickness;
                    filters.thickness.max = thicks[thicks.length - 1].thickness;
                    this.setState({resource: resource, filters: filters, ready: true});
                } else {
                    this.setState({ready: true});
                }
            });
        });
    };

    // Cycles search setter
    loadAndSetCycles = (q = '', searchCyclesFn) => {
        searchCyclesFn(q, cycles => {
            const cycleOptions = cycles.map(x => ({
                value: x.id,
                label: x.name,
                color: x.color,
            }));
            this.setState({cycleOptions});
        });
    };

    // Categories search setter
    loadAndSetCategories = (q = '', searchCyclesFn) => {
        searchCyclesFn(q, categories => {
            const categoryOptions = categories.map(x => ({
                value: x.id,
                label: x.name,
                formula: x.formula,
            }));
            this.setState({categoryOptions});
        });
    };

    // Source tree search setter
    sourceTreeSearchFn = (callback, result) => {
        const sourceTreesOptions = [{
            label: 'Not Processed',
            options: [],
        }, {
            label: 'Processed',
            options: [],
        }];

        result.processed = result.processed.map(x => ({value: x.id, label: x.name}));
        result.not_processed = result.not_processed.map(x => ({value: x.id, label: x.name}));
        sourceTreesOptions[1].options = result.processed;
        sourceTreesOptions[0].options = result.not_processed;

        this.setState({sourceTreesOptions});

        callback([...result.processed, ...result.not_processed]);
    };

    // Thicks setter
    loadAndSetTreeThicks = (searchFn) => {
        const {resource} = this.state;
        if (resource.tree) {
            searchFn(resource.tree.id,
                thicks => this.setState({thicks}),
            );
        } else {
            this.setState({thicks: []});
        }
    };

    // Table selection functions
    onGlobalSelect = () => {
        this.setState({selectedAll: !this.state.selectedAll});
    };

    onRowSelect = (row, isSelected) => {
        let currentlySelected = this.state.selectedRows;

        if (isSelected && !currentlySelected.includes(row.id)) {
            currentlySelected.push(row.id);
            this.setState({selectedRows: currentlySelected, selectedAll: false});
        }
        if (!isSelected) {
            currentlySelected = currentlySelected.filter(s => s !== row.id);
            this.setState({selectedRows: currentlySelected, selectedAll: false});
        }
    };

    onSelectAll(isSelected, rows) {
        let currentlySelected = this.state.selectedRows;
        let ids = rows.map(x => x.id);
        if (isSelected) {
            ids.forEach(x => {
                if (!currentlySelected.includes(x)) {
                    currentlySelected.push(x);
                }
            });
            this.setState({selectedRows: currentlySelected, selectedAll: false});
        }
        if (!isSelected) {
            ids.forEach(x => {
                currentlySelected.splice(currentlySelected.indexOf(x), 1);
            });
            this.setState({selectedRows: currentlySelected, selectedAll: false});
        }
    }

    formatPhoneNumber(number) {
        const cleanedNumber = number.replace(/\D/g, '');
        return cleanedNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');

    }

}

export const map = elements => {
    return elements.map(s => ({value: s.id, label: s.name}));
};

ResourceComponent.propTypes = {
    history: PropTypes.object,
};


// WEBPACK FOOTER //
// ./src/common/ResourceComponent.js